module.exports = __webpack_public_path__ + "static/img/so1_2.aacf3ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so1_2.jpg
// module id = 6akb
// module chunks = 11